<template>
    <div class="questionnaire-question">
        <h6 class="question-title">
            {{questionIn.question}}
        </h6>
        <design-2021-questionnaire-answer-component v-model="answer"
                                                    @input="updateQuestion">
        </design-2021-questionnaire-answer-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-questionnaire-question-component",
    props: {
        questionIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: this.questionIn.answers.length !== 0 ? this.questionIn.answers[0].answer : '',
        }
    },
    methods: {
        updateQuestion(){
            const question = this.questionIn;
            if(question.answers.length > 0){
                this.questionIn.answers[0].answer = this.answer;
            } else {
                this.questionIn.answers = [];
                this.questionIn.answers.push({
                    answer: this.answer,
                });
            }
            this.$emit('updated-question', question);
        }
    }
}
</script>

<style scoped lang="scss">
    .questionnaire-question {
        margin: map-get($grid-gutter-spacing, 'ten');
        padding:  map-get($grid-gutter-spacing, 'twenty-one')  map-get($grid-gutter-spacing, 'fiften');

        &:nth-child(odd){
            background-color: $secondary-background-color;
        }
    }
</style>
